import { defineStore } from 'pinia';

const getDefaultHeaderTitle = (): HeaderTitle => {
  return {
    type: null,
    backBtnVisible: false,
    centerText: '',
    cartCount: 0,
    backFunc: null,
    onlyCart: false,
  }
}

export const useRootStore = defineStore('root', {
  state: () => ({
    loading: false,
    toastShow: false,
    toastText: '',
    confirm: false,
    confirmTitle: '',
    confirmMessage: '',
    confirmCancelBtn: '',
    confirmOkayBtn: '',
    confirmCancelFunc: null as (() => void) | null,
    confirmOkayFunc: null as (() => void) | null,
    confirmIsShowClose: false,
    confirmButtonDisabled: false,
    messageDialogShow: false,
    messageDialogTitle: '',
    messageDialogMessage: '',
    messageDialogButtonText: '',
    messageDialogClickListener: null as (() => void) | null,
    headerTitle: getDefaultHeaderTitle(),
    isShowFooter: true,
  }),
  getters: {
    // Header 영역 back 버튼 처리
    headerBackFunc: (state) => {
      return state.headerTitle.backFunc || (() => {
        const router = useRouter();
        if (router.options.history.state?.back) {
          router.go(-1);
        } else {
          history.back();
        }
      });
    }
  },  
  actions: {
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    toast(msg: string) {
      if(isPcWeb()){
        return
      }
      this.toastShow = true;
      this.toastText = msg;
      
      setTimeout(() => {
        this.toastShow = false;
      }, 2000);
    },
    resetToast() {
      this.toastShow = false;
      this.toastText = '';
    },
    openConfirm(title: string, message: string, cancelBtn: string, okayBtn: string, cancelFunc: (() => void) | null, okayFunc?: () => void, isShowClose?: boolean, buttonDisabled?: boolean) {
      this.confirmTitle = title;
      this.confirmMessage = message;
      this.confirmCancelBtn = cancelBtn;
      this.confirmOkayBtn = okayBtn;
      this.confirmCancelFunc = cancelFunc;
      this.confirmOkayFunc = okayFunc ?? null;
      this.confirm = true;
      this.confirmIsShowClose = isShowClose ?? false;
      this.confirmButtonDisabled = buttonDisabled ?? false;
    },
    openConfirmWithCancle(title: string, message: string, cancelBtn: string, okayBtn: string, cancelFunc: () => void, okayFunc: () => void) {
      this.openConfirm(title, message, cancelBtn, okayBtn, cancelFunc, okayFunc, true);
    },
    resetConfirm() {
      this.confirmTitle = '';
      this.confirmMessage = '';
      this.confirmCancelBtn = '';
      this.confirmOkayBtn = '';
      this.confirmCancelFunc = null;
      this.confirmOkayFunc = null;
      this.confirm = false;
      this.confirmIsShowClose = false;
      this.confirmButtonDisabled = false;
    },
    showMessageDialog(message: string, buttonText: string, buttonClick?: () => void) {
      this.messageDialogTitle = '';
      this.messageDialogMessage = message;
      this.messageDialogButtonText = buttonText;
      this.messageDialogClickListener = buttonClick ?? null;
      this.messageDialogShow = true;
    },
    showMessageDialogTitle(title: string, message: string, buttonText: string, buttonClick: () => void) {
      this.messageDialogTitle = title;
      this.messageDialogMessage = message;
      this.messageDialogButtonText = buttonText;
      this.messageDialogClickListener = buttonClick;
      this.messageDialogShow = true;
    },
    resetMessageDialog() {
      this.messageDialogTitle = '';
      this.messageDialogMessage = '';
      this.messageDialogButtonText = '';
      this.messageDialogClickListener = null;
      this.messageDialogShow = false;
    },
    setHeaderTitle(data: HeaderTitle) {
      this.headerTitle.type = data.type;
      this.headerTitle.backBtnVisible = data.backBtnVisible ?? false;
      this.headerTitle.centerText = data.centerText ?? '';
      this.headerTitle.cartCount = data.cartCount ?? 0;
      this.headerTitle.backFunc = data.backFunc ?? null;
      this.headerTitle.onlyCart = data.onlyCart ?? false;
    },
    resetHeaderTitle() {
      this.headerTitle = getDefaultHeaderTitle();
    },
    setFooter(isShowFooter: boolean) {
      this.isShowFooter = isShowFooter;
    }
  },
});